export enum Pathes {
  ROOT = '/',
  ACCESS_GROUPE = 'access-group',
  ROLES_ACCESS = 'roles-access',
  ACTIONS = 'actions',
  ROLES_LABEL = 'roles-label',
  USERS = 'users',
  NUMBERS = 'numbers',
  PACKAGES = 'packages',
  OPERATORS = 'operators',
  TRANSACTIONS = 'transactions',
  PAYMENTS = 'payments',
  CHARGES = 'charges',
  ORDERS = 'orders',
  SMS = 'sms',
  SEND_SMS = 'send-sms',
  LIST = 'list',
  ADD = 'add',
  FORM = 'form',
  ATTACH_ACCESS = 'attach-access/:id',
  ATTACH_ACTION = 'attach-action/:id',
  EDIT = 'edit/info/:id',
  DETAILS = 'details/:id',
}
export const toRoot = [
  '/login',
  '/login/verify',
  '/signup',
  '/signup/verify',
  '/forget-password',
  '/change-password',
  '/home',
];
export enum AppStors {
  GOOGLE = 'google',
  APPLE = 'apple',
  META = 'meta',
}
export enum FILTER {
  INPUT = 'input',
  RANGE = 'range',
  AUTO_COMPLETE = 'autoComplete',
  MULTI_SELECT = 'multiSelect',
}

export enum DateUnits {
  MINUTES = 'MINUTES',
  HOUR = 'HOUR',
  DAY = 'DAY',
  WEEK = 'WEEK',
  MONTH = 'MONTH',
}
